module.exports = __webpack_public_path__ + "static/shruti-7befbc69ed4ba4b3b35429a462129555.png";